import React from 'react';
import HomeOptionButton from '@/components/home/HomeOptionButton';
import { getFilteredHomeOptions } from '@/constants/home-options';
import { useUserStore } from '@/stores/useUser.store';
import { LogOut } from 'lucide-react';

const HomePage = () => {
  const user = useUserStore.getState().user;
  const homeOptions = getFilteredHomeOptions(user?.role);
  const logout = useUserStore(state => state.logout);

  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-2 px-4 gap-4 py-[18px] md:grid-cols-3 md:gap-5">
        {homeOptions.map(({ icon, title, to, role, disabled }, idx) => (
          <HomeOptionButton key={idx + title} icon={icon} title={title} to={to} disabled={disabled} />
        ))}
        <button onClick={logout}>
          <HomeOptionButton key={'logout'} icon={LogOut} title={'LogOut'} to={'#'} disabled={true} />
        </button>
      </div>
    </div>
  );
};

export default HomePage;
